


import React, { useState, useEffect } from "react";
import "./TeamDerictory.css";
import Teamemployeetable from "./Teamemployeetable.jsx";
import * as employeeService from "../../../Servicefile/employeeService";
import ClipLoader from "react-spinners/ClipLoader";
import GroupsIcon from "@mui/icons-material/Groups";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import WorkIcon from "@mui/icons-material/Work";
import PersonOffIcon from "@mui/icons-material/PersonOff";

const initialStats = [
    { title: "Total Team", value: 0, icon: <GroupsIcon />, color: "#1e3a8a" },
    { title: "Finance", value: 0, icon: <RestaurantIcon />, color: "#f59e0b" },
    { title: "Managers", value: 0, icon: <WorkIcon />, color: "#334155" },
    { title: "Support", value: 0, icon: <PersonOffIcon />, color: "#ef4444" },
];

export default function TeamStats() {
    const [stats, setStats] = useState(initialStats);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    // Get sidebar state and listen for changes
    useEffect(() => {
        // Initial check
        const checkSidebar = () => {
            const sidebarValue = localStorage.getItem("sidebar");
            setIsSidebarOpen(sidebarValue === "open");
        };

        checkSidebar();

        // Listen for storage events
        const handleStorageChange = (e) => {
            if (e.key === "sidebar") {
                setIsSidebarOpen(e.newValue === "open");
            }
        };

        // Custom event for same tab
        const handleCustomEvent = () => {
            checkSidebar();
        };

        // Override localStorage.setItem
        const originalSetItem = localStorage.setItem;
        localStorage.setItem = function (key, value) {
            originalSetItem.apply(this, arguments);
            if (key === "sidebar") {
                window.dispatchEvent(new Event("sidebarChange"));
            }
        };

        window.addEventListener("storage", handleStorageChange);
        window.addEventListener("sidebarChange", handleCustomEvent);

        // Interval fallback
        const interval = setInterval(checkSidebar, 500);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
            window.removeEventListener("sidebarChange", handleCustomEvent);
            clearInterval(interval);
            localStorage.setItem = originalSetItem;
        };
    }, []);

    // Handle window resize
    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Function to get number of columns based on screen width AND sidebar state
    const getGridColumns = () => {
        // Mobile screens (below 500px)
        if (windowWidth < 500) {
            return 2;
        }

        // Tablet screens (500px - 768px)
        if (windowWidth >= 500 && windowWidth < 768) {
            return 2;
        }

        // Desktop screens (768px and above)
        if (windowWidth >= 769 && windowWidth < 999) {
            // If sidebar is OPEN → show 3 cards per row
            // If sidebar is CLOSED → show 4 cards per row
            return isSidebarOpen ? 3 : 4;
        }
        if (windowWidth >= 1000) {
            // If sidebar is OPEN → show 3 cards per row
            // If sidebar is CLOSED → show 4 cards per row
            return isSidebarOpen ? 4 : 4;
        }

        return 4; // Default fallback
    };

    // Fetch employees and calculate stats
    const fetchTeamStats = async () => {
        try {
            setLoading(true);

            const employees = await employeeService.fetchEmployees();


            const totalTeam = employees.length;

            // ✅ STATUS
            const inactiveEmployees = employees.filter(emp => emp.enabled === false);

            // ✅ ROLES (use handlingRole only)
            const finance = employees.filter(emp =>
                (emp.handlingRole || "").toLowerCase().includes("finance")
            ).length;

            const managers = employees.filter(emp =>
                (emp.handlingRole || "").toLowerCase().includes("manager")
            ).length;

            const support = employees.filter(emp =>
                (emp.handlingRole || "").toLowerCase().includes("support")
            ).length;

            setStats([
                {
                    title: "Total Team",
                    value: totalTeam,
                    icon: <GroupsIcon />,
                    color: "#1e3a8a"
                },
                {
                    title: "Finance",
                    value: finance,
                    icon: <RestaurantIcon />,
                    color: "#f59e0b"
                },
                {
                    title: "Managers",
                    value: managers,
                    icon: <WorkIcon />,
                    color: "#334155"
                },
                {
                    title: "Support",
                    value: support,
                    icon: <PersonOffIcon />,
                    color: "#ef4444"
                }
            ]);

            setError(null);

        } catch (error) {
            console.error("❌ Failed to fetch team stats:", error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTeamStats();
        const intervalId = setInterval(fetchTeamStats, 300000);
        return () => clearInterval(intervalId);
    }, []);

    const columns = getGridColumns();

    return (
        <>
            <div className="team-stats-grid" style={{
                display: "grid",
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
                gap: "16px",
                marginBottom: "25px"
            }}>
                {loading ? (
                    <div style={{
                        gridColumn: `span ${columns}`,
                        display: "flex",
                        justifyContent: "center",
                        padding: "40px"
                    }}>
                        <ClipLoader color="#e66d33" size={40} />
                    </div>
                ) : error ? (
                    <div style={{
                        gridColumn: `span ${columns}`,
                        textAlign: "center",
                        padding: "40px",
                        color: "#dc3545"
                    }}>
                        Error loading statistics: {error}
                    </div>
                ) : (
                    stats.map((item, index) => (
                        <div key={index} className="team-stat-card">
                            <div className="team-stat-icon">
                                <span className="material-icons-round" style={{ color: item.color }}>
                                    {item.icon}
                                </span>
                            </div>
                            <div className="team-stat-info">
                                <div className="team-stat-value">{item.value}</div>
                                <div className="team-stat-title">{item.title}</div>
                            </div>
                        </div>
                    ))
                )}
            </div>
            <Teamemployeetable />
        </>
    );
}